import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { HUMAN_RESOURCES_QUERY } from "graphql/humanResources";

// Bearer token is stored by auth flow in localStorage
const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

// Apollo Client instance for human resources service
let humanResourcesClient = null;

/**
 * Initialize Apollo Client for human resources service
 * @returns {ApolloClient} Configured Apollo Client instance
 */
const getHumanResourcesClient = () => {
  if (humanResourcesClient) {
    return humanResourcesClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  humanResourcesClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return humanResourcesClient;
};

export async function fetchHumanResources() {
  try {
    const client = getHumanResourcesClient();

    const { data } = await client.query({
      query: HUMAN_RESOURCES_QUERY,
      fetchPolicy: "network-only",
    });

    console.log("Human Resources GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Human Resources GraphQL error:", error);
    throw error;
  }
}

